import { render, staticRenderFns } from "./TiptapLink.vue?vue&type=template&id=1e9f732c"
import script from "./TiptapLink.vue?vue&type=script&lang=js"
export * from "./TiptapLink.vue?vue&type=script&lang=js"
import style0 from "./TiptapLink.vue?vue&type=style&index=0&id=1e9f732c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports